module.exports = __webpack_public_path__ + "img/max-person-approve.aabe94a0.svg";